<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <!-- <ul class="flex justify-center">
        <el-segmented
          v-model="state.model.type"
          :props="{
            label: 'Text',
            value: 'Key',
          }"
          :options="[
            { Key: 0, Text: '对公转账' },
            { Key: 1, Text: '其他' },
          ]"
          class="c-segmented"
        />
      </ul>
      <template v-if="state.model.type === 0">
        <el-form-item
          label="选择到款"
          prop="bank_receipt"
          :rules="[{ required: true, message: '请选择到款', trigger: 'blur' }]"
        >
          <el-select
            v-model="state.model.bank_receipt"
            value-key="id"
            @change="
              (item) => {
                state.model.uncollected_amount = item.uncollected_amount;
                delete state.model.amount;
              }
            "
          >
            <template #label="{ label, value }">
              <div class="flex w-full gap-x-5 items-center">
                <text>{{ value.payment_name }}</text>
                <text>{{ value.payment_opening_bank }}</text>
                <li class="flex-1">{{ value.payment_account }}</li>
                <li class="flex items-center text-gray-400 text-xs">
                  可认领金额：<c_money
                    :key="value.uncollected_amount"
                    :value="value.uncollected_amount"
                    :prefix="false"
                  />
                </li>
              </div>
            </template>
            <el-option
              v-for="item in state.dk_data"
              :key="item"
              :label="item.payment_name"
              :value="item"
            >
              <div class="flex w-full gap-x-5 items-center">
                <text>{{ item.payment_name }}</text>
                <text>{{ item.payment_opening_bank }}</text>
                <li class="flex-1">{{ item.payment_account }}</li>
                <li class="flex items-center text-gray-400 text-xs">
                  可认领金额：<c_money
                    :key="item.uncollected_amount"
                    :value="item.uncollected_amount"
                    :prefix="false"
                  />
                </li>
              </div>
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadDk()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <ul class="flex gap-x-10">
          <el-form-item label="可认领金额">
            <c_money
              :key="state.model.uncollected_amount"
              :value="state.model.uncollected_amount"
              :size="30"
            />
          </el-form-item>
          <el-form-item
            label="本次认领金额"
            prop="amount"
            :rules="[
              {
                required: true,
                message: '请输入本次认领金额',
                trigger: 'blur',
              },
            ]"
          >
            <el-input-number
              v-model="state.model.amount"
              :precision="2"
              class="number-input-left number-input-suffix"
              suffix="元"
              :max="state.model.uncollected_amount"
              @focus="$onFocus"
            ></el-input-number>
          </el-form-item>
        </ul>
        <el-form-item label="认领说明">
          <el-input v-model="state.model.intro" type="textarea"></el-input>
        </el-form-item>
      </template>
      <template v-else> -->
      <ul class="flex gap-10">
        <c_cell title="金额">
          <template #default>
            <c_money
              :key="state.detail?.amount"
              :value="state.detail?.amount"
              :size="20"
              color="#000"
              :prefix="false"
            />
          </template>
        </c_cell>
        <c_cell title="已收">
          <template #default>
            <c_money
              :key="state.detail?.collected_amount"
              :value="state.detail?.collected_amount"
              :size="20"
              color="#080"
              :prefix="false"
            />
          </template>
        </c_cell>
        <c_cell title="未收">
          <template #default>
            <c_money
              :key="state.detail?.uncollected_amount"
              :value="state.detail?.uncollected_amount"
              :size="20"
              bold
              :prefix="false"
            />
          </template>
        </c_cell>
      </ul>
      <ul class="flex gap-x-10 mt-2">
        <el-form-item
          label="收款方式"
          prop="d_collect_type_id"
          :rules="[
            { required: true, message: '请选择收款方式', trigger: 'blur' },
          ]"
        >
          <el-select v-model="state.model.d_collect_type_id" class="!w-56">
            <el-option
              v-for="item in state.skfs_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            ></el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadSkfs()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="本次收款金额"
          prop="amount"
          :rules="[
            {
              required: true,
              message: '请输入本次收款金额',
              trigger: 'blur',
            },
          ]"
        >
          <template #label>
            <div class="flex items-center gap-x-2 float-right">
              本次收款金额
              <el-button
                color="#1e90ff"
                link
                @click="state.model.amount = state.detail.uncollected_amount"
              >
                自动填入
              </el-button>
            </div>
          </template>
          <el-input-number
            v-model="state.model.amount"
            :precision="2"
            class="number-input-left number-input-suffix"
            suffix="元"
            :max="state.model.uncollected_amount"
            @focus="$onFocus"
          ></el-input-number>
        </el-form-item>
      </ul>
      <el-form-item label="收款说明">
        <el-input v-model="state.model.intro" type="textarea"></el-input>
      </el-form-item>
      <!-- </template> -->
      <el-form-item
        label="附件"
        prop="files"
        :rules="[
          {
            required: true,
            message: '请上传银行到款水单',
            trigger: 'blur',
          },
        ]"
      >
        <template #label>
          <div class="float-right flex items-center">
            <text>附件</text>
            <text class="text-xs ml-2 text-red-500">请上传银行到款水单</text>
          </div>
        </template>
        <c_UploadFile
          :value="state.model.files"
          @change="
            (data) => {
              state.model.files = data;
            }
          "
        />
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  collectedplan_detail,
  collectedplan_collect,
} from "@/http/zhangdanshoukuan";
import { data_getBankReceipt, dic_getCollectedType } from "@/http/data";
import { post_response } from "@/utils/funcs";
import { attachment_upload } from "@/http/attachment";
import { ElMessageBox } from "element-plus";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      detail: {},
      model: {
        meeting_collected_plan_id: props.id,
        type: 1,
        files: [],
      },
    });
    onMounted(() => {
      onLoad();
      // onLoadDk();
      onLoadSkfs();
    });

    const onLoad = () => {
      if (props.id) {
        collectedplan_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.detail = res.data?.data || {};
          }
        });
      }
    };

    //获取到款记录
    const onLoadDk = () => {
      data_getBankReceipt({
        "uncollected_amount>": 0,
      }).then((res) => {
        if (res.status == 200) {
          state.dk_data = res.data?.data?.list || [];
        }
      });
    };

    //获取收款方式
    const onLoadSkfs = () => {
      dic_getCollectedType().then((res) => {
        if (res.status == 200) {
          state.skfs_data = res.data?.data || [];
        }
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(`您确定提交收款申请吗？`, "账单收款", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true,
            cancelButtonClass: "is-plain",
          }).then(() => {
            state.model.bank_receipt_id = state.model.bank_receipt?.id;
            state.model.attachment = JSON.stringify(
              state.model.files?.map((m) => m.id),
            );
            collectedplan_collect(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onFileChange,
      onLoadDk,
      onLoadSkfs,
    };
  },
};
</script>
<style scoped></style>
